<template>
  <div class="w-80 max-h-[360px] overflow-y-auto rounded-2xl bg-white p-2 shadow-2xl ring-1 ring-[#1c4848]/10" role="listbox" aria-label="Components">
    <p v-if="!items.length" class="px-3 py-4 text-sm text-[#1c4848]/50">No component by that name.</p>
    <button
      v-for="(item, i) in items"
      :key="item.key"
      type="button"
      role="option"
      :aria-selected="i === active"
      class="flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left transition-colors"
      :class="i === active ? 'bg-[#1c4848]/[0.07]' : 'hover:bg-[#1c4848]/5'"
      @mouseenter="active = i"
      @mousedown.prevent="command(item)"
    >
      <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#1c4848]/5 text-lg text-[#1c4848]"><iconify-icon :icon="item.icon" aria-hidden="true" /></span>
      <span class="min-w-0">
        <span class="block text-sm font-semibold text-[#1c4848]">{{ item.label }}</span>
        <span class="block truncate text-xs text-[#1c4848]/50">{{ item.hint }}</span>
      </span>
    </button>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  items: { type: Array, required: true },
  command: { type: Function, required: true },
});

const active = ref(0);
watch(() => props.items, () => { active.value = 0; });

function onKeyDown(event) {
  if (event.key === 'ArrowDown') {
    active.value = (active.value + 1) % Math.max(1, props.items.length);
    return true;
  }
  if (event.key === 'ArrowUp') {
    active.value = (active.value - 1 + props.items.length) % Math.max(1, props.items.length);
    return true;
  }
  if (event.key === 'Enter' && props.items[active.value]) {
    props.command(props.items[active.value]);
    return true;
  }
  return false;
}

defineExpose({ onKeyDown });
</script>
